import React from 'react';
import { Link } from 'react-router-dom';
import { guideDoutoUrl } from '../lib/doutoHandoff';

const track = (ctaType) => () => window.eidocAnalytics?.capture('guide_cta_clicked', { cta_type: ctaType });

/** Convite único ao calculador, no topo do guia. Um link de texto, nada fixo nem flutuante. */
export function GuideCalcInvite() {
  return (
    <Link
      to="/#calculadora"
      onClick={track('calculator_top')}
      className="no-print whitespace-nowrap text-sm text-[var(--primary)] underline"
    >
      Calcular o MEEM agora →
    </Link>
  );
}

/** Segundo convite, ao final do conteúdo principal, apontando para o Douto. */
export function GuideDoutoNextStep() {
  return (
    <p className="no-print mt-10 border-t border-[var(--border)] pt-4 text-[0.9375rem] text-[var(--text-muted)]">
      Depois do escore, o caso continua. Se quiser levar uma dúvida de conduta adiante, você pode conversar sobre ela no{' '}
      <a
        href={guideDoutoUrl()}
        target="_blank"
        rel="noopener"
        onClick={track('douto_next_step')}
        className=" text-[var(--primary)] underline"
      >
        Douto<span className="sr-only"> (abre em nova aba)</span> ↗
      </a>
      .
    </p>
  );
}
